import React from "react";
import "./CheckboxGroup.scss";
import { bem } from "../../helpers";
import PropTypes from "prop-types";
import FieldGroup from "../Field/Group.js";
import Checkbox from "../Checkbox/Checkbox.js";
import List from "../List/List";

export class CheckboxGroup extends FieldGroup {
  inputType = "checkbox";

  componentDidMount = () => {
    let state = {};

    if (this.props.collapsible) {
      state.collapsed = true;
    }

    if (this.props.filterable) {
      state.filter = "";
      state.filterResults = [...this.props.options];
    }

    if (state) {
      this.setState({
        ...this.state,
        ...state,
      });
    }
  };

  isFilterable = () => {
    var b = false;
    var t = 1;
    if (typeof this.props.filterable === "boolean") {
      b = this.props.filterable;
    } else if (this.props.filterable === "true") {
      b = true;
    } else if (typeof this.props.filterable === "number") {
      b = true;
      t = this.props.filterable;
    } else if (!isNaN(parseInt(this.props.filterable))) {
      b = true;
      t = parseInt(this.props.filterable);
    }

    return b && t <= this.props.options.length;
  };

  onChange = (e, props) => {
    if (this.props.format === "object") {
      this.asObject(e, props);
    } else {
      this.asArray(e, props);
    }
  };

  //value as array
  asArray = (e, props) => {
    var data = props.propsForFields || props;

    if (data && data.onChange) {
      var newVal = [...(data.formData[data.id] || [])];

      const key = Object.keys(e)[0];
      const i = newVal.indexOf(key);

      //removes unchecked values
      if (i === -1) {
        newVal.push(key);
      } else {
        newVal.splice(i, 1);
      }

      data.onChange({ [data.id]: newVal });
    }
  };

  //value as object
  asObject = (e, props) => {
    var data = props.propsForFields || props;
    if (data && data.onChange) {
      var newVal = {
        ...(data.formData[data.id] || {}),
        ...e,
      };

      //removes unchecked values
      Object.keys(newVal).forEach((key) => {
        if (!newVal[key]) {
          delete newVal[key];
        }
      });

      data.onChange({ [data.id]: newVal });
    }
  };

  filterResults = (query, label) => {
    const values = this.props.options.filter((option) => {
      return (
        option?.label &&
        (!query || option.label.toLowerCase().indexOf(query.toLowerCase()) > -1)
      );
    });

    this.setState({ filterResults: values, filter: query });
  };

  renderLabel = () => {
    const { label, collapsible } = this.props;
    if (label || collapsible) {
      return (
        <legend className={bem("group", "label")}>
          <h3>{label}</h3>
          {collapsible && (
            <a
              onClick={() =>
                this.setState({ collapsed: !this.state.collapsed })
              }
            >
              {this.state.collapsed ? "Edit" : "Close"}
            </a>
          )}
        </legend>
      );
    }
  };

  getValuesLabels = (props) => {
    var data = props.propsForFields || props || {};
    var values = (data.formData && data.formData[data.id]) || [];

    if (typeof values === "object" && !Array.isArray(values)) {
      values = Object.keys(values).filter((value) => values[value]);
    }

    return values.map((value) => {
      if (props.options && props.options.length > 0) {
        return props.options?.find((obj) => obj.value === value)?.label;
      }
    });
  };

  getValues = (props) => {
    var data = props.propsForFields || props || {};
    var values = (data.formData && data.formData[data.id]) || [];
    if (!Array.isArray(values) && typeof values === "object") {
      values = Object.keys(values).filter((value) => values[value]);
    }
    return values;
  };

  isChecked = (props, value) => {
    var values = this.getValues(props);
    return values.indexOf(value) > -1;
  };

  renderInput = () => {
    const {
      id,
      options,
      scrollable,
      propsForFields,
      collapsible,
      label,
      className,
      formData,
    } = this.props;

    const optionsArr = this.isFilterable()
      ? this.state?.filterResults
      : options;

    return (
      <div className={bem("group")}>
        {this.isFilterable() && (!collapsible || !this.state.collapsed) && (
          <input
            type="text"
            value={this.state.filter}
            onChange={(e) => this.filterResults(e.target.value, label)}
            placeholder={`Filter ${label}`}
          />
        )}
        <div
          className={bem(
            "group",
            "checkboxes",
            [
              scrollable && "scrollable",
              collapsible && "collapsible",
              this.isFilterable() && "filterable",
            ],
            className
          )}
          onClick={
            this.state.collapsed
              ? (e) => {
                  e.preventDefault();
                  this.setState({ collapsed: !this.state.collapsed });
                }
              : undefined
          }
        >
          {!this.state.collapsed && (
            <div>
              {optionsArr?.map((option) => (
                <Checkbox
                  {...propsForFields}
                  onChange={(e) => this.onChange(e, this.props)}
                  id={option.value}
                  parentId={id}
                  key={option.value}
                  {...option}
                  inputProps={{ value: option.value }}
                  checked={
                    option.checked || this.isChecked(this.props, option.value)
                  }
                />
              ))}
            </div>
          )}

          {collapsible && this.state.collapsed && (
            <List
              className={bem("group", "values")}
              deliminated=", "
              data={this.getValuesLabels(this.props) || []}
            />
          )}
        </div>
      </div>
    );
  };
}

CheckboxGroup.defaultProps = {
  format: "array",
  filterable: false,
  collapsible: false,
};

CheckboxGroup.propTypes = {
  ...FieldGroup.propTypes,
  format: PropTypes.string,
  filterable: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  collapsible: PropTypes.bool,
  scrollable: PropTypes.bool,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.any.isRequired,
    })
  ),
};

export default CheckboxGroup;
